import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  MarkOfferSoldBodySchema,
  MarkOfferSoldResponseSchema,
  SalePreviewResponseSchema,
} from '../schemas/campaign-sale.js';
import { OfferIdSchema } from '../schemas/offer.js';

export const campaignSale = {
  // POST /offers/:id/mark-sold (campaign-sale / "Campaign sale endpoint").
  markSold: endpoint(
    'POST',
    '/offers/:id/mark-sold',
    z.object({ id: OfferIdSchema }).merge(MarkOfferSoldBodySchema),
    MarkOfferSoldResponseSchema,
  ),
  // GET /offers/:id/sale-preview (campaign-sale / "Sale preview"). No query
  // params — the confirmed campaign is identified by :id alone.
  salePreview: endpoint(
    'GET',
    '/offers/:id/sale-preview',
    z.object({ id: OfferIdSchema }).strict(),
    SalePreviewResponseSchema,
  ),
};
